module.exports = __webpack_public_path__ + "static/media/Autonomia-APRENDIZAJE.2b6bec9e.svg";